// extracted by mini-css-extract-plugin
export default {"tabContainer":"AnalyticsPdfNavigation_tabContainer__KMDcZ"};